// src/components/DisableDialog.tsx

import React, { useState, useEffect } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import {  fetchReasons } from "../../api/apiFunctions";
import disabledsvg from '../../assets/images/icon-disable.svg';

interface DeleteProps{
    open:boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    handleDeleteConfirm:(reason:any,comment:string)=>void;
    isSideMenu?: boolean;
    menuName?: string;
}


const DeletexEVMPD:React.FC<DeleteProps> =(props) => {
    const {open,setOpen,handleDeleteConfirm, isSideMenu,menuName}=props;
  const { t } = useTranslation();
  const [reason, setReason] = useState({ id: "" });
  const [reasonList, setReasonList] = useState([]);
  const [comments, setComments] = useState("");


  useEffect(() => {
    if (open) {
      if (!isSideMenu) {
        const getReasons = async () => {
          const reasons = await fetchReasons();
          setReasonList(reasons);
        };
        getReasons();
        setReason({ id: '' });
      }
      setComments('');
    }
  }, [open, isSideMenu]);

  const handleDisable = async() => {
    if (isSideMenu) {
      handleDeleteConfirm({ id: comments }, ""); // Pass comments as reason
    } else {
      handleDeleteConfirm(reason, comments);
    }
  };

  const onClickNo=()=>{
    setReason({id:''});
    setComments('');
    setOpen(false);
  }
 
  const onClose=()=>{
    setOpen(false);
  }
  return (
    <Dialog
      className="popup-dialog"
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose();
        }
      }}
      disableEscapeKeyDown
      maxWidth="md"
      sx={{
        '.MuiDialog-paper': { width: '600px' },
         '& .MuiDialog-container': {
      display: 'flex',
      alignItems: 'flex-start', // Top-aligned
      justifyContent: 'center',
      marginTop: isSideMenu ? '100px' : '0px', // Space from the top
    },
    '& .MuiPaper-root': {
      mt: 4, // margin-top to move it slightly down from the top
    },
      }}
    BackdropProps={{
    style: {
      backgroundColor: "rgba(0, 0, 0, 0.2)", // ✅ dim, transparent backdrop
    },
  }}
  PaperProps={{
    style: {
      width:  isSideMenu? "500px" :"600px",
      borderRadius: 8,
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)", // subtle shadow
      backgroundColor: "#fff", // dialog box itself remains white
    },
  }}
  
    >
      <DialogTitle>
        {t('Delete')+" "+t(menuName || '')}
      </DialogTitle>
      <Box component="form" sx={{ display: 'flex', flexDirection: 'column' }}>
      <DialogContent className="form-group popup-content delete-dialog"  >
        {isSideMenu ? (
          <Grid container spacing={2} className="alert-emptystate">
          <Grid item xs={12} alignItems="center" sx={{ mt: 1, ml: 20 }}>
            <svg
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              width="100"
              height="100"
              fill="none"
            >
              <path
                fill="#0A0A30"
                d="M16.773 10.083a.75.75 0 00-1.49-.166l1.49.166zm-1.535 7.027l.745.083-.745-.083zm-6.198 0l-.745.083.745-.083zm-.045-7.193a.75.75 0 00-1.49.166l1.49-.166zm5.249 7.333h-4.21v1.5h4.21v-1.5zm1.038-7.333l-.79 7.11 1.491.166.79-7.11-1.49-.166zm-5.497 7.11l-.79-7.11-1.49.166.79 7.11 1.49-.165zm.249.223a.25.25 0 01-.249-.222l-1.49.165a1.75 1.75 0 001.739 1.557v-1.5zm4.21 1.5c.892 0 1.64-.67 1.74-1.557l-1.492-.165a.25.25 0 01-.248.222v1.5z"
              ></path>

              <path
                fill="#0C66E4"
                d="M11 6a1 1 0 00-1 1v.25H7a.75.75 0 000 1.5h10a.75.75 0 000-1.5h-3V7a1 1 0 00-1-1h-2z"
                className="animate"
                fillRule="evenodd"
                clipRule="evenodd"
              ></path>
            </svg>
            </Grid>
           
            <Grid
              item
              sx={{ position: "relative", marginBottom: "20px", flex: "1", mt: 2 }}
            >
               <h5 className='alert-notify-text mb-24 text-center'>{t('common.deleteConfirmMsg')}</h5>
              <TextField
                size="small"
                label={<span>{t("Reason")} <span style={{color: 'red'}}>*</span></span>}
                inputProps={{ maxLength: 2000 }}
                multiline
                rows={4}
                value={comments}
                onChange={(event) => setComments(event.target.value)}
              />
              <span className="rtq-number-tips comment-count-right">
                {comments ? comments.length : 0} / 2000
              </span>
            </Grid>
          </Grid>
        ) : (
          <Grid>
            <img src={disabledsvg} style={{ width: '200px', marginLeft: 'calc(50% - 100px)', marginBottom: '10px' }}></img>
            <h5 className='alert-notify-text mb-24 text-center'>{t('disableProductTitle')}</h5>
            <Grid>
              <Autocomplete
                sx={{
                  "& .MuiOutlinedInput-root": { padding: 0, "flex-wrap": "nowrap" },
                  "& .MuiTextField-root": {
                    marginLeft: 0,
                    marginTop: 0,
                    marginBottom: 0,
                  },
                  "& .MuiOutlinedInput-root .MuiAutocomplete-input": { border: "none" },
                  "& .MuiFormControl-root .MuiInputBase-root input:focus": {
                    outline: "none !important",
                  },
                  "& .MuiAutocomplete-inputRoot": { paddingLeft: "10px" },
                  flex: 1,
                }}
                className="custom-autocomplete"
                renderTags={(selectedOptions: any) => {
                  return <Chip label={selectedOptions.length + " selected"} />;
                }}
                value={reason}
                options={reasonList}
                data-testid="autoCompleteBox"
                getOptionLabel={(option: any) => option.name || ""}
                renderInput={(params: any) => (
                  <TextField
                    {...params}
                    required
                    label={t("reasonForDisable")}
                    inputProps={{
                      ...params.inputProps,
                      onKeyDown: (e) => {
                        if (e.keyCode === 13) {
                          e.preventDefault();
                        }
                      },
                    }}
                  />
                )}
                onChange={(event: any, value: any) => {
                  setReason(value);
                }}
              />
            </Grid>
            <Grid
              item
              sx={{ position: "relative", marginBottom: "20px", flex: "1" }}
            >
              <TextField
                size="small"
                label={t("Comments")}
                inputProps={{ maxLength: 2000 }}
                multiline
                rows={4}
                value={comments}
                onChange={(event) => setComments(event.target.value)}
              />
              <span className="rtq-number-tips comment-count-right">
                {comments ? comments.length : 0} / 2000
              </span>
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="text" size="small" data-testid="noButton" onClick={onClickNo}>
          {t('No')}
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={handleDisable}
          disabled={isSideMenu ? !comments.trim() : !(reason && reason.id)}
          data-testid="yesButton"
        >
          {t('Yes')}
        </Button>
      </DialogActions>
      </Box>
    </Dialog>
   
  );
};

export default DeletexEVMPD;
